import { Button, Card, Checkbox, DateInput, Dropdown, Select } from "components";
import { Controller, useFormContext } from "react-hook-form";
import { useToggle } from "utils";
import { FilterBugetManager as FilterBugetManagerType } from "../types";
import moment from "moment";

type FilterBugetManagerProps = {
  toggleDetail: ReturnType<typeof useToggle>
  toggleSubHeader: ReturnType<typeof useToggle>
  toggleZeroValue: ReturnType<typeof useToggle>
  toggleAccountNumber: ReturnType<typeof useToggle>
  onFilterSubmit: (data: FilterBugetManagerType) => void
}

export default function FilterBugetManager(props: FilterBugetManagerProps) {
  const methods = useFormContext<FilterBugetManagerType>()

  const [DateStart, DateEnd] = methods.watch(["start_range", "end_range"])

  const currencyDropdown = [
    { value: "1", label: "IDR" },
    { value: "2", label: "USD" },
  ]

  

  return (
    <section className="my-2">
      <Card>
        <Card.Body>
          <section className="container flex-col lg:flex lg:flex-row justify-center lg:justify-between items-end pt-5">
            <div className="w-full lg:w-full lg:flex lg:justify-start items-end">
              {/* <div className="w-full lg:w-[200px] lg:me-4">
                <SelectAccountGroup type="profitLoss" />
              </div> */}

              <div className="lg:me-4 my-2 lg:my-0">
                <label className="label">
                  <span className="label-text font-bold">RANGE</span>
                </label>
                <div className="join items-end">
                  <Dropdown
                    buttonClass="rounded-r-none whitespace-nowrap"
                    className="join-item"
                    buttonLabel="Month"
                  />

                  <DateInput
                    className="join-item rounded-l-none"
                    selected={DateStart ? moment(DateStart).toDate() : null}
                    onChange={res => {
                      if (res) {
                        methods.setValue("start_range", moment(res).format("YYYYMM"));
                      }
                    }}
                    dateFormat={"MM/yyyy"}
                    showMonthYearPicker
                  />

                  <DateInput
                    className="join-item rounded-l-none"
                    selected={DateEnd ? moment(DateEnd).toDate() : null}
                    onChange={res => {
                      if (res) {
                        methods.setValue("end_range", moment(res).endOf("month").format("YYYYMM"));
                      }
                    }}
                    dateFormat={"MM/yyyy"}
                    showMonthYearPicker
                  />
                </div>
              </div>

              <div className="w-full lg:w-[200px] lg:me-4 my-2 lg:my-0">
                <Controller
                  name="currency"
                  control={methods.control}
                  render={({ field }) => (
                    <Select
                      label="Currency"
                      placeholder="Select Currency"
                      className="w-full "
                      options={currencyDropdown}
                      onChange={(filter) => field.onChange(filter?.value)}
                      value={currencyDropdown.find((option) => option.value === field.value)}
                    />
                  )}
                />
              </div>

              <div className="w-full lg:w-[100px] lg:me-4">
                <Button
                  type="button"
                  permission="AP023"
                  disabled={methods.formState.isSubmitting}
                  onClick={() => methods.handleSubmit((data) => props.onFilterSubmit(data))()}
                  className="w-full btn bg-black dark:bg-primary text-white dark:btn-primary rounded-lg"
                >
                  {methods.formState.isSubmitting && (<span className="loading loading-spinner" />)}
                  Update
                </Button>
              </div>
            </div>

            <div className="w-full lg:ms-4 mt-8 flex pb-1 justify-end items-center">
              <section className="px-2">
                <Checkbox
                  defaultChecked={props?.toggleDetail.isActive}
                  onChange={(e) => props?.toggleDetail.setActive(e.target.checked)}>
                  Detail
                </Checkbox>
              </section>

              <section className="px-2">
                <Checkbox
                  defaultChecked={props?.toggleSubHeader.isActive}
                  onChange={(e) => props?.toggleSubHeader.setActive(e.target.checked)}>
                  Sub Header
                </Checkbox>
              </section>

              <section className="px-2">
                <Checkbox
                  defaultChecked={props?.toggleZeroValue.isActive}
                  onChange={(e) => props?.toggleZeroValue.setActive(e.target.checked)}>
                  Zero Value
                </Checkbox>
              </section>

              <section className="px-2">
                <Checkbox
                  defaultChecked={props?.toggleAccountNumber.isActive}
                  onChange={(e) => props?.toggleAccountNumber.setActive(e.target.checked)}>
                  Account Number
                </Checkbox>
              </section>
            </div>
          </section>
        </Card.Body>
      </Card>
    </section>
  )
}